import { Link } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger } from "./tabs";
import { NotificationKey } from "@common/state/notificationState";
import { Badge } from "./badge";
import { renderBadgeNumber } from "@common/state/badgeNumberState";

interface Tab {
  name: string;
  route: string;
  id: string;
  badgeNumber?: number;
  notificationKey?: NotificationKey;
}

interface Props<T> {
  tabs: Tab[];
  selectedTab: T;
}

export const NavigationTabs = <T extends string>({
  tabs,
  selectedTab,
}: Props<T>) => {
  return (
    <Tabs value={selectedTab}>
      <TabsList>
        {tabs.map(({ route, id, name, badgeNumber = 0 }) => (
          <Link key={route} to={route}>
            <TabsTrigger value={id} className="flex items-center space-x-2">
              <div>{name}</div>
              {badgeNumber > 0 && (
                <Badge>{renderBadgeNumber(badgeNumber)}</Badge>
              )}
            </TabsTrigger>
          </Link>
        ))}
      </TabsList>
    </Tabs>
  );
};
